import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { compose } from 'redux';
import {
    isErrorBannerSrp,
    isFetchingBannerSrp,
    selectBannerDataByCategoryIdnPlatform
} from 'Selectors/items';
import withRouter from 'HOCs/withRouter';
import { categoryIdSelector } from 'Selectors/categories';
import { PLATFORM } from 'Constants/device.APP_TARGET';
import { getBannerSrpAction } from 'Actions/items';
import { urls } from 'Reducers/items';

const withStaticBannerCarouselSrp = WrappedComponent => {
    class WithStaticBannerCarouselSrp extends React.Component {
        componentDidMount() {
            this.fetchStaticBannerCarousel();
        }

        componentDidUpdate(prevProps) {
            const { location, selectedCategoryId } = this.props;

            const locationOrCategoryChanged = (
                prevProps?.location?.key !== location.key
                || prevProps?.location?.pathname !== location?.pathname
                || prevProps?.location?.search !== location?.search
                || prevProps.selectedCategoryId !== selectedCategoryId
            );

            if (locationOrCategoryChanged) {
                this.fetchStaticBannerCarousel();
            }
        }

        fetchStaticBannerCarousel = () => {
            const { dispatch, selectedCategoryId } = this.props;

            dispatch(getBannerSrpAction(PLATFORM, selectedCategoryId));
        }

        render() {
            const { dataSrpListItemBannerById, ...restProps } = this.props;

            return (
                <WrappedComponent
                    { ...restProps }
                    dataSrpListItemBanner={ dataSrpListItemBannerById }
                />
            );
        }
    }

    WithStaticBannerCarouselSrp.propTypes = {
        dispatch: PropTypes.func.isRequired,
        selectedCategoryId: PropTypes.string,
        location: PropTypes.object.isRequired,
        params: PropTypes.object,
        dataSrpListItemBannerById: PropTypes.array,
        allDataSrpListItemBanner: PropTypes.object,
        track: PropTypes.func,
        isFetchingGetBannerSrp: PropTypes.bool,
        isErrorBannerSrp: PropTypes.bool
    };

    WithStaticBannerCarouselSrp.defaultProps = {
        selectedCategoryId: '-1',
        params: {}
    };

    /**
     * Makes an items API call for the wrapped component
     */
    WithStaticBannerCarouselSrp.fetchData = (...args) => {
        const [dispatch, renderProps] = args;
        const { selectedCategoryId } = renderProps;

        // if the wrapped component have its own 'fetchData'
        // call that first then proceed with fetching the items data
        const promises = [
            (WrappedComponent.fetchData ? WrappedComponent.fetchData(...args) : Promise.resolve())
        ];

        return Promise.all(promises).then(() => {
            return dispatch(getBannerSrpAction(PLATFORM, selectedCategoryId));
        });
    };

    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    WithStaticBannerCarouselSrp.displayName = `withStaticBannerCarouselSrp(${wrappedComponentName})`;

    const mapStateToProps = (state, ownProps) => {
        const categoryID = categoryIdSelector(state, ownProps.params);

        return {
            isFetchingGetBannerSrp: isFetchingBannerSrp(state, `${urls.getBannerSrp}#categoryid=${categoryID}&platform=web-${PLATFORM}`),
            isErrorBannerSrp: isErrorBannerSrp(state, `${urls.getBannerSrp}#categoryid=${categoryID}&platform=web-${PLATFORM}`),
            selectedCategoryId: categoryID ?? '-1',
            dataSrpListItemBannerById: selectBannerDataByCategoryIdnPlatform(state, `web-${PLATFORM}`, categoryID ?? '-1')
        };
    };

    const connectedComponent = compose(
        withRouter,
        connect(mapStateToProps)
    )(WithStaticBannerCarouselSrp);

    return hoistNonReactStatic(connectedComponent, WrappedComponent, { fetchData: true });
};

export default withStaticBannerCarouselSrp;
